import styled from "styled-components";
import { theme } from "@themes";

export const ContentModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .react-slidedown.my-dropdown-slidedown {
    width: 100%;
  }
  .react-slidedown.my-dropdown-slidedown > div {
    width: 100%;
  }
`;
export const ModalTitle = styled.label`
  font-size: 20px;
  color: ${({ theme }) => theme.neutral.black};
  font-weight: 500;
  position: absolute;
  left: 31px;
  top: 17px;
`;

export const ContentModalActiveSurvey = styled.div`
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  width: 800px;
  height: 650px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: 100vh;
  }
`;

export const CloseModalActiveSurvey = styled.div`
  height: 60px;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalActiveSurvey = styled.div`
  height: 492px;
  display: flex;
  background-color: #e9e9e9;
  position: relative;
  p {
    font-size: 16px;
    color: ${({ theme }) => theme.neutral.black};
    font-weight: 400;
    height: auto;
    width: 352px;
  }

  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ButtonActiveSurvey = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 67px;
  height: 34px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: rgba(46, 46, 46, 1);
  }
`;
export const ButtonActiveSurveyCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 67px;
  height: 34px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 0 10px;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const ActionButtons = styled.div`
  height: 66px;
  display: flex;
  margin: auto;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  bottom: 0;
  background-color: ${({ theme }) => theme.neutral.white};
  border-top: 1px solid ${({ theme }) => theme.neutral.gray[400]};
`;

export const SearchField = styled.div`
  width: 248px;
  height: 48px;
  position: absolute;
  top: 22px;
  right: 132px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid #c4c4c4;
  @media only screen and (max-width: 768px) {
    width: 50%;
  }
  svg {
    position: absolute;
    right: 10px;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
    background: transparent;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
    background: transparent;
  }
  input::placeholder {
    color: #8f9bb3;
  }
`;
export const QuestionsContainer = styled.div`
  position: relative;
  width: 100%;
  top: 78px;
  height: 415px;
  overflow-y: auto;
  display: flex;
  justify-content: center;
`;
export const BlockWrapper = styled.div`
  display: grid;
  grid-auto-rows: 1fr 1px;
  grid-template-columns: 100%;
  position: relative;
  svg {
    cursor: pointer;
    width: 27%;
    justify-self: center;
    height: 27%;
  }
  .question-select-icon {
    width: fit-content;
    height: fit-content;
    cursor: pointer;
    position: absolute;
    right: 15px;
    top: 30px;
    z-index: 8;
  }
`;
export const QuestionsContent = styled.div`
  left: 75px;
  width: 547px;
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
`;
export const EmptyRecordContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const PreviewPanel = styled.div`
  width: 80%;
  margin-top: 10px;
  height: 100%;
  overflow-y: auto;
`;
